export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/file-solid-d6e379bf4c98229a4f5e7d23675bf524.svg";